import React from 'react'
import { Title } from 'src/components/Title'

import { Positions } from '../../components/Positions'
import { TabBar } from '../../components/TabBar'
import './AllPositions.scss'

export function AllPositions() {
  return (
    <div className="all-positions page">
      <div className="all-positions__inner-page-container">
        <Title title="Vaults" />
        <div className="tabbar-container">
          <TabBar
            headerClassName="all-positions__tab-bar-header"
            headerStyle={{
              width: 260,
              marginBottom: '1rem',
            }}
            items={[
              {
                title: 'My Vaults',
                component: <Positions onlyShowMyPositions />,
              },
              { title: 'All Vaults', component: <Positions /> },
            ]}
          />
        </div>
      </div>
    </div>
  )
}
